import './_video.scss';
import component from './video';

export default component;
